import React from "react";
import { Link } from "react-router-dom";
export default function NotFound() {
  return (
    <div className="blz-container py-20 text-center">
      <div className="font-mono text-6xl text-slate-300">404</div>
      <h1 className="font-display text-2xl font-bold mt-3">Page not found</h1>
      <Link to="/" className="btn-primary mt-6">Back home</Link>
    </div>
  );
}
